<template>
  <div class="l-header" id="header">
    <div v-show="showSideMenu" class="m-mask" @click="onClose"></div>
    <div class="l-header_ctn jtf_between">
      <div class="l-header_logo">
        <div class="l-header_logo-img">
          <router-link :to="isLogin ? { name: 'home' } : { name: 'Top' }">
            <img src="@/assets/images/cfind-logo.png" alt="" />
          </router-link>
        </div>
        <div class="l-header_logo-title"></div>
      </div>
      <!-- <div class="l-header_nav" v-if="!isTopPage">
        <div :class="['l-header_btn']">
          <div @click="onClose" v-if="showSideMenu && mobileDisplay">
            <img src="@/assets/images/x-close-black.svg" />
          </div>
          <router-link :to="{ name: 'News' }" class="link_blue">
            お知らせ
            <div v-if="isShowNewsIcon" class="notice_banner">
              <span>NEW!</span>
            </div>
          </router-link>
          <template v-if="!mobileDisplay">
            <template v-if="isLogin">
              <button @click="confirmLogout" class="link_blue ml-50 mr-50">
                ログアウト
              </button>
              <div @click="onClose">
                <Notification />
              </div>
            </template>
            <template v-else>
              <router-link :to="{ name: 'Register term' }" class="link_blue"
                >会員登録</router-link
              >
              <div
                @click="onClose"
                class="l-header_btn-login"
                :class="showSideMenu ? 'link_blue' : ''"
              >
                <router-link to="/login" class="btn_login-link">
                  <button class="btn_login">ログイン</button>
                </router-link>
                <router-link class="text_login-link" to="/login">
                  ログイン</router-link
                >
              </div>
            </template>
          </template>
        </div>
        <div class="l-header_user-signed" v-if="getAccessToken()">
          <span class="user-signed_num">{{formatNumber(String(this.totalEstate?.number))}}</span>
          <span class="user-signed_title">物件登録</span>
        </div>
        <div class="l-header_btn-icon">
          <img
            @click="onOpen"
            src="https://img.icons8.com/ios/50/000000/menu--v6.png"
            class="menu-icon"
          />
        </div>
      </div> -->
      <MobileSideBar v-if="mobileDisplay" />
    </div>
    <ModalLayout ref="confirm-logout-condition">
      <div class="modal-confirm-delete">
        <p class="title">{{ $i18n.t('confirm_logout') }}</p>
        <br />
        <div class="d-flex justify-content-center">
          <button
            class="btn-cancel"
            @click.prevent="$refs['confirm-logout-condition'].closeModal()"
          >
            {{ $i18n.t('message.modal.cancel') }}
          </button>
          <button class="btn-delete" @click.prevent="logOut">
            {{ $i18n.t('message.modal.ok') }}
          </button>
        </div>
      </div>
    </ModalLayout>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ModalLayout from '@/components/Modals/Modal.vue';
import Notification from '@/components/layout/notification.vue';
import { getFcmToken, getAccessToken } from '@/utils/token';
import { HAS_NEW_ICON } from '@/constants/news';
import * as screen from '@/constants/screen';

export default {
  components: {
    ModalLayout,
    // Notification
  },
  data() {
    return {
      isOpenMenu: false,
      openClass: '',
      mobileDisplay: false,
      // isShowNewsIcon: false,
    };
  },

  computed: {
    ...mapGetters({
      isLogin: 'auth/isLogin',
      showSideMenu: 'common/showSideMenu',
    }),
    ...mapGetters('news', ['allNews']),
    ...mapGetters('news', ['isShowNewsIcon']),
    ...mapGetters('estate', ['totalEstate']),
    isTopPage() {
      if (process.env.VUE_APP_COLLECT_MODE) {
        return true;
      }
      return false;
    }
  },

  created() {
    const w = window.innerWidth;
    if (w < 1081) {
      this.mobileDisplay = true;
    }
    if (getAccessToken()?.length) {
      this.getTotalNotificationUnread();
    }

    if (!screen.SCREEN_TOP_AND_TOP_DETAIL.includes(this.$route.name)) {
      if (!this.totalEstate?.number) {
        this.getTotalEstate();
      }
    }

    if (!screen.SCREEN_TOP.includes(this.$route.name)) {
      this.checkNews();
    }
  },
  watch: {
    $route(to, from) {
      if (to.fullPath !== from.fullPath && getAccessToken()?.length) {
        this.getTotalNotificationUnread();
        if (!screen.SCREEN_TOP_AND_TOP_DETAIL.includes(to.name)) {
          if (!this.totalEstate?.number) {
            this.getTotalEstate();
          }
        }
      }
    }
  },

  methods: {
    getAccessToken,
    ...mapActions('notification', ['getTotalNotificationUnread']),
    onOpen() {
      this.$store.commit('common/SET_SHOW_SIDE_MENU', true);
      // this.isOpenMenu = true;
      // this.openClass = 'r-0';
    },
    onClose() {
      this.$store.commit('common/SET_SHOW_SIDE_MENU', false);
      // this.isOpenMenu = false;
      // this.openClass = '';
    },
    formatNumber(n) {
      return n.replace(/\D/g, '')
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    async logOut() {
      this.$root.$refs.loading.start();
      this.$refs['confirm-logout-condition'].closeModal();
      const fcmToken = getFcmToken();
      if (fcmToken) await this.$store.dispatch('common/unSubscribeTokenFirebase', fcmToken);
      await this.$store.dispatch('auth/logOut');
      this.$router.push({ name: 'Top' });
      this.$root.$refs.loading.finish();
    },
    confirmLogout() {
      this.$refs['confirm-logout-condition'].openModal();
    },
    async getAllNews() {
      this.isLoading = true;
      await this.$store.dispatch('news/getAllNews');
      this.isLoading = false;
    },
    async checkNews() {
      if (this.allNews.length === 0) {
        await this.getAllNews();
      }
      const isNews = this.allNews.find(
        item => item.new_icon === HAS_NEW_ICON
      );
      if (isNews) {
        await this.$store.commit('news/setNewIcon', true);
        // this.isShowNewsIcon = true;
      }
    },
    async getTotalEstate() {
      const params = {
        status: 1,
        current_price: null,
        type: null,
        prefecture: null,
        construct_date: null,
      };
      await this.$store.dispatch('estate/getTotalEstate', params);
    },
  },
};
</script>

<style scoped>
  .m-mask {
    z-index: 100 !important;
  }
</style>
